import { KeycloakAuth } from './keycloak'

export enum AuthEvent {
  UserDisabled = 'gim:user-disabled',
}

let sharedInitPromise: Promise<void> | null = null

export function getInitPromise(keycloakAuth: KeycloakAuth): Promise<void> {
  if (sharedInitPromise === null) {
    sharedInitPromise = keycloakAuth.init()
  }
  return sharedInitPromise
}

/** Reset shared init promise so tests can assert fresh init behaviour. */
export function __resetSharedInitPromiseForTesting(): void {
  sharedInitPromise = null
}
